import { render, staticRenderFns } from "./ButtonElementPublish.vue?vue&type=template&id=6cccd1e6&"
import script from "./ButtonElementPublish.vue?vue&type=script&lang=ts&"
export * from "./ButtonElementPublish.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonElementPublish.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports